module.exports = __webpack_public_path__ + "static/media/coursera_logo.ca3b3a0f.png";